import * as React from 'react';
import { UnitSensorInterface } from './shared';
import { Header, Tab, Form, Modal, Icon } from 'semantic-ui-react';
import ConfigurationsInput from 'src/components/inputs/ConfigurationsInput';
import UnitSensorRenameInput from 'src/components/inputs/UnitSensorRenaming';
import './UnitSensorEdit.scss';
import UnitSensorChart from 'src/container/UnitSensor/UnitSensorChart';

interface UnitSensorEditProps {
    fromObject: Partial<UnitSensorInterface>;
    resolveRow: (unitSensor?: UnitSensorInterface) => any;
    rejectRow: (err?: Error | { isNormal: boolean, typedId: number }) => any;
    isNew?: boolean;
}

export default class UnitSensorEdit extends React.Component<
    UnitSensorEditProps, 
    any
> {
    resolveRow?: (unitSensor?: UnitSensorInterface) => any;
    rejectRow?: (err?: any) => any;
    
    constructor(props: UnitSensorEditProps) {
        super(props);
        const { resolveRow, rejectRow, fromObject } = props;

        this.resolveRow = resolveRow;
        this.rejectRow = rejectRow;
        
        this.state = { 
            ...fromObject,
            occuringTriggers: fromObject.snoozes || [],
            configurations: fromObject.configurations || [],
        };
    }

    render() {
        const changeHandler = this.handleChange.bind(this);
        const submitHandler = this.handleSubmit.bind(this);
        const panes = [
            { menuItem: 'Details', render: this.renderDefault.bind(this, this.state, changeHandler) },
            { menuItem: 'Configurations', render: this.renderConfigurations.bind(this, this.state, changeHandler)  }
        ];

        if (!this.props.isNew) {
            panes.unshift({ 
                menuItem: 'History', render: this.renderChart.bind(this)
            });
        }
        return(
            <Modal 
                closeIcon
                size="fullscreen"
                open={true}
                onClose={this.handleClose.bind(this)}
                className="standard-padding center-margin tb-margin"
                style={{
                    marginTop: 10, 
                    marginLeft: 'auto', 
                    marginRight: 'auto',
                    padding: '21px',
                    boxSizing: 'content-box',
                    overflowY: 'scroll'
                }}
                dimmer="inverted"
                closeOnDimmerClick={true}
            >
                <Modal.Header>Editing UnitSensor {this.state.name}</Modal.Header>
                <Form 
                    onSubmit={submitHandler}
                >
                    <Modal.Content>
                        <Modal.Description className="top-margin">
                            <Tab panes={panes} />

                        </Modal.Description>
                            
                    </Modal.Content>
                    <Modal.Actions>
                        <Form.Button primary float="right" className="top-margin">
                            Submit <Icon name="chevron right"/>
                        </Form.Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        );
    }

    renderDefault ( { alias, priority, name, clientId, unitSensorRenaming }: any, changeHandler: any) {
        return (
            <Tab.Pane>
                <Form.Field>
                    <label>Name</label>
                    <Form.Input 
                        placeholder="Name" 
                        name="name" 
                        defaultValue={name} 
                        onChange={changeHandler} 
                    />
                </Form.Field>
                <Form.Field>
                    <label>Unit Sensor Renames</label>
                    
                    <UnitSensorRenameInput
                        name="unitSensorRenaming"
                        onChange={changeHandler}
                        initialValue={unitSensorRenaming || []}
                    />
                </Form.Field>
            </Tab.Pane>
        );
    }

    renderConfigurations({ configurations }: any, changeHandler: any ) {
        return (
            <Tab.Pane>
                <Header>Configurations</Header>
                <Form.Field>
                    <ConfigurationsInput
                        name="configurations"
                        onChange={changeHandler}
                        initialValue={configurations || []}
                    />
                </Form.Field>
            </Tab.Pane>
        );
    }  
    renderChart(chart: any) {
        return (
            <Tab.Pane>
                <UnitSensorChart
                    fromObject={this.state}
                />
            </Tab.Pane>
        );

    }

    handleChange(
        e: any, 
        { 
            name, value 
        }: {
            name: string, 
            value: any
        }
    ) {
        this.setState({ [name]: value });
    }

    handleSubmit = (event: any) => {
        if (event.keyCode !== 13) {
            this.resolveRow(this.state as  any);
        }
    }

    handleClose = () => {
        this.rejectRow({ isNormal: true, typedId: this.state.typedId});
    }
}


// WEBPACK FOOTER //
// ./src/container/UnitSensor/UnitSensorEdit.tsx